export const loginRequestScope: Array<string> = [
  import.meta.env.VITE_APP_MSAL_REFRESH_TOKEN || "",
  import.meta.env.VITE_APP_MSAL_PRODUCT_SCOPE || "",
];

export const refreshTokenScope: Array<string> = [
  import.meta.env.VITE_APP_MSAL_REFRESH_TOKEN || "",
];
